import {
  type AffineCssVariables,
  combinedDarkCssVariables,
  combinedLightCssVariables,
} from '@streamlain/theme';
import { unsafeCSS } from 'lit';

const toolbarColorKeys: Array<keyof AffineCssVariables> = [
  '--streamlain-background-overlay-panel-color',
  '--streamlain-v2-layer-background-overlayPanel' as never,
  '--streamlain-v2-layer-insideBorder-blackBorder' as never,
  '--streamlain-v2-icon-primary' as never,
  '--streamlain-background-error-color',
  '--streamlain-background-primary-color',
  '--streamlain-background-tertiary-color',
  '--streamlain-icon-color',
  '--streamlain-icon-secondary',
  '--streamlain-border-color',
  '--streamlain-divider-color',
  '--streamlain-text-primary-color',
  '--streamlain-hover-color',
  '--streamlain-hover-color-filled',
];

export const lightToolbarStyles = (selector: string) => `
  ${selector}[data-app-theme='light'] {
    ${toolbarColorKeys
      .map(key => `${key}: ${unsafeCSS(combinedLightCssVariables[key])};`)
      .join('\n')}
  }
`;

export const darkToolbarStyles = (selector: string) => `
  ${selector}[data-app-theme='dark'] {
    ${toolbarColorKeys
      .map(key => `${key}: ${unsafeCSS(combinedDarkCssVariables[key])};`)
      .join('\n')}
  }
`;
